<div class="d-grid grid-column gp-20 ">
  <div class="d-flex flex-column justify-content-center align-items-center w-100 list-of-vehicle">
    <div class="position-relative">
      <img *ngIf="content?.image" src="{{ content?.image }}" class="card-img-top" [alt]="pageType" />
      <img *ngIf="!content?.image" [src]="service?.getDefaultImageByCategory(content?.category)" class="card-img-top" [alt]="pageType" />
    </div>
  </div>
  <div class="d-flex flex-column justify-content-center w-100 vehicle-list-anchor">
    <div>
      <div>
        {{ content?.name }}
      </div>
      <div *ngFor="let detail of content?.primaryDetailsList">
        <div *ngIf="detail">{{ detail }}</div>
      </div>
    </div>
  </div>
</div>